export default __webpack_public_path__ + "fonts/732ea61587e3da9057b1593b8c06d612.svg";